import React from 'react'
import { useTranslation } from 'react-i18next';

const LoopComponent = () => {
  const { t } = useTranslation();
  return (
    <div>
        <img src="/assets/images/parentdash/independence.gif" alt={t('auth.loop')} style={{width:'100%'}} />
    </div>
  )
}

export default LoopComponent